import { createContext } from "react";

type MobileScreenContextType = {
  isMobileScreen: boolean;
};

export const MobileScreenContext =
  createContext<MobileScreenContextType | null>(null);
